


const state = {
  userSearch: null
}
const mutations = {
  setSearchTerm (state, data) {
    state.userSearch = data
  }
}
const  actions = {
}
const getters = {
  searchTerm: state => {
    return state.userSearch
  },
}

export default {
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/products.js